<nz-button-group>
  @for (button of buttons; track index; let index = $index) {
    <button
      nz-button
      nz-tooltip
      nzTooltipPlacement="bottom"
      [disabled]="button?.disabled"
      [nzTooltipTitle]="button.tooltip"
      [nzType]="nzType"
      (click)="button?.callback()">
      <ui-icon
        class="sh-lighter-icon"
        [key]="button.icon"></ui-icon>
    </button>
  }
</nz-button-group>
